import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { InstanceDto } from '@plugins/smartforms-lib/instance';

import { DataService } from '../services';

export const instanceResolver: ResolveFn<
  InstanceDto | Observable<InstanceDto>
> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const dataService = inject(DataService);
  return dataService.instance() ?? dataService.fetchInstance();
};
